import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {
  signedUrl: SafeResourceUrl;
  // iOS/Android browsers cannot render a PDF inside an <iframe> (blank or first page only), so pdf.js is used there.
  readonly isMobile = PdfViewerComponent.detectMobile();
  pdfBlob: Blob | null = null;
  loadError = false;

  constructor(
    public dialogRef: MatDialogRef<PdfViewerComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: { signedUrl: string }
  ) {
    this.signedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.signedUrl);
  }

  ngOnInit(): void {
    if (this.isMobile) {
      void this.loadBlob();
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  onLoadFailed(): void {
    this.loadError = true;
  }

  get fileName(): string {
    try {
      const segment = decodeURIComponent(new URL(this.data.signedUrl).pathname.split('/').pop() ?? '');
      if (segment) {
        return /\.pdf$/i.test(segment) ? segment : `${segment}.pdf`;
      }
    } catch {
      // fall through to default name
    }
    return 'document.pdf';
  }

  private async loadBlob(): Promise<void> {
    try {
      const response = await fetch(this.data.signedUrl);
      if (!response.ok) {
        throw new Error(`PDF request failed: ${response.status}`);
      }
      this.pdfBlob = await response.blob();
    } catch {
      this.loadError = true;
    }
  }

  private static detectMobile(): boolean {
    const nav = navigator;
    const isIpadOs = nav.platform === 'MacIntel' && nav.maxTouchPoints > 1;
    return isIpadOs || /Android|iPhone|iPad|iPod/i.test(nav.userAgent);
  }
}
